import { Typography } from '@mui/material';
import PageContainer from '../Components/PageContainer';
import InvoiceInitiationTable from '../Components/Invoicing/InvoiceInitiationTable';

function InvoicingInitiationPage() {
    return (
        <PageContainer>
            <Typography variant="h3" sx={{ fontSize: 22 }}>
                Invoicing Initiation
            </Typography>

            <InvoiceInitiationTable />
        </PageContainer>
    );
}

export default InvoicingInitiationPage;
